/** Awaits the promise without breaking control flow.
 *  `ok === true`:   Returns the successful value
 *  `ok === false`:  Returns the error that was thrown
 *
 * This is heavilly inspired by how packages like zod and languages like Go and Rust handle errors
 *
 * ### Example
 * ```typescript
 * const todos = await safePromise(fetch('http://localhost:3000/api/todo'))
 *
 * if (!todos.ok) {
 *    console.error(todos.error)
 *    return process.exit(1)
 * }
 *
 * return todos.value
 * ```
 */
// prettier-ignore
export async function safePromise<T>(promise: Promise<T>): Promise<
  | { ok: true, value: T }
  | { ok: false, error: Error }
> {
    try {
        return {
            ok: true,
            value: await promise,
        }
    } catch (error: any) {
        return {
            ok: false,
            error: error instanceof Error 
                ? error 
                : new Error(
                    typeof error === 'string' 
                        ? error 
                        : 'toString' in error && typeof error.toString === 'function' 
                            ? error.toString() 
                            : JSON.stringify(error)
                ),
        }
    }
}

export function sleep(durationMs: number) {
    return new Promise(res => {
        setTimeout(() => res(durationMs), durationMs);
    });
}
